<template lang='pug'>
Reload(
  v-slot='{ reload }'
)
  v-container
    Dialog2
      template(
        v-slot:default='{ shouldShowDialogUpdate }'
      )
        WeightToolbar(
          :date='date'
          @update:date='date => $router.push({ params: { date } })'
          @weighIn='shouldShowDialogUpdate(true)'
        )
      template(
        v-slot:dialog
      )
        WeightUpdate(
          @success='reload'
        )
    WeightsGetMonth(
      :key='from_date_int'
      :date_int='from_date_int'
    )
</template>

<script>
import { pipe } from 'lodash/fp';

import {
  date_to_date_int,
  date_int_to_from_date_int,
} from '@thomasphan/helpers-fatsecret';

import Dialog2 from '@thomasphan/vue-components/src/components/Dialog2.vue';
import Reload from '@thomasphan/vue-components/src/components/Reload.vue';
import WeightsGetMonth from '@thomasphan/vue-components/src/components/WeightsGetMonth.vue';
import WeightToolbar from '@thomasphan/vue-components/src/components/WeightToolbar.vue';
import WeightUpdate from '@thomasphan/vue-components/src/components/WeightUpdate.vue';

const from_date_int = function ()
{
  return pipe
  ([
    date_to_date_int,
    date_int_to_from_date_int,
  ])
  (this?.date);
};

export default
{
  components:
  {
    Dialog2,
    Reload,
    WeightsGetMonth,
    WeightToolbar,
    WeightUpdate,
  },
  computed:
  {
    from_date_int,
  },
  props:
  {
    date: { required: true }
  },
};
</script>